import React from "react"

import { navigate } from "gatsby"
import { MilesDistance, defaultArea } from "@common/constant"
import SearchType from "./Sections/SearchType"
import MinPrice from "./Sections/MinPrice"
import MaxPrice from "./Sections/MaxPrice"
import Bedrooms from "./Sections/Bedrooms"
import PropertyType from "./Sections/PropertyType"
import SearchArea from "./Sections/SearchArea"
import Miles from "./Sections/Miles"

const FilterMenu = ({
  showFilter,
  propertySearch,
  srchTypeVal,
  handleSearchType,
  priceOptions,
  minPriceVal,
  maxPriceVal,
  setMinPriceVal,
  setMaxPriceVal,
  bedroomVal,
  setBedroomVal,
  propertyVal,
  departmentVal,
  setPropertyVal,
  srchTypeValSel,
  pathName,
  setShowFilter,
  areaVal,
  setAreaInputVal,
  setShowSuggestion,
  showSuggestion,
  filterType,
  bedPlus,
  maximumBeds,
  studio,
  setMilesVal,
  milesVal,
}) => {
  const excludeSold = (event) => {
    let include_path = `${pathName}`
    if (event.target.checked) {
      include_path = `${pathName}exclude-sold/`
    } else {
      include_path = include_path.replace("exclude-sold/", "")
    }
    setShowFilter(false)
    navigate(include_path)
  }

  const excludeLet = (event) => {
    let includePath = `${pathName}`
    if (event.target.checked) {
      includePath = `${pathName}exclude-let/`
    } else {
      includePath = includePath.replace("exclude-let/", "")
    }
    setShowFilter(false)
    navigate(includePath)
  }

  // console.log("defaultArea==>", defaultArea, areaVal)

  return (
    <div className={`filter-menu ${showFilter ? "show_filter" : ""}`}>
      <button
        type="button"
        className="menu-close d-xl-none"
        aria-label="menuclose"
        onClick={() => setShowFilter(false)}
      >
        <i className="icon icon-close" />
      </button>

      <SearchType
        selectOptions={propertySearch?.search_type}
        searchTypeVal={srchTypeValSel}
        handleChange={handleSearchType}
        classNameWrapper="search_type d-flex d-md-none"
      />
      <div className="divider d-none" />

      <div className="input-box d-md-none">
        <i className="icon icon-search" />
        {/* <input type="text" placeholder="Enter your search location" /> */}
        <SearchArea
          areaVal={areaVal}
          setAreaInputVal={setAreaInputVal}
          setShowSuggestion={setShowSuggestion}
          showSuggestion={showSuggestion}
        />
      </div>

      {(departmentVal === "residential" || departmentVal === "commercial") &&
        areaVal && (
          <>
            <Miles
              selectOptions={MilesDistance}
              milesVal={milesVal}
              handleChange={setMilesVal}
              isDisabled={defaultArea.toLowerCase() === areaVal}
              // classNameWrapper="d-none"
              // isDisabled={!!areaInputVal}
            />

            <div className="divider d-none d-md-flex" />
          </>
        )}

      <MinPrice
        selectOptions={priceOptions}
        searchTypeVal={srchTypeVal}
        minPriceVal={minPriceVal}
        maxPriceVal={maxPriceVal}
        handleChange={(val) => setMinPriceVal(val)}
      />
      <div className="divider d-none d-md-block" />

      <MaxPrice
        selectOptions={priceOptions}
        searchTypeVal={srchTypeVal}
        minPriceVal={minPriceVal}
        maxPriceVal={maxPriceVal}
        handleChange={(val) => setMaxPriceVal(val)}
      />
      <div className="divider d-none d-md-block" />

      {departmentVal !== "commercial" && (
        <>
          <Bedrooms
            bedroomVal={bedroomVal}
            handleChange={(val) => setBedroomVal(val)}
            bedPlus={bedPlus}
            maximumBeds={maximumBeds}
            studio={studio}
          />
          <div className="divider d-none d-md-block" />
        </>
      )}

      <PropertyType
        selectOptions={propertySearch?.property_type}
        propertyVal={propertyVal}
        handleChange={(val) => setPropertyVal(val)}
      />

      {filterType === "search_result" && (
        <>
          {srchTypeVal === "sales" && (
            <div className="checkbox-container include_checkbox d-md-none">
              <label className="container-wrap">
                <input
                  type="checkbox"
                  value="For Sale"
                  onChange={excludeSold}
                />
                <span className="checkmark" /> Exclude Under Offer, Sold
              </label>
            </div>
          )}

          {srchTypeVal === "lettings" && (
            <div className="checkbox-container include_checkbox d-md-none">
              <label className="container-wrap">
                <input type="checkbox" value="To Let" onChange={excludeLet} />
                <span className="checkmark" /> Exclude Let Agreed, Let
              </label>
            </div>
          )}
        </>
      )}

      <button
        className="search-btn d-xl-none button button-primary"
        type="submit"
      >
        Search
      </button>
    </div>
  )
}
export default FilterMenu
